import { format } from 'date-fns';

const formatDateWithTimezone = (date: Date): string => format(date, "yyyy-MM-dd'T'HH:mm:ssxxx");

export default formatDateWithTimezone;
